import {Component, Input} from '@angular/core';
import {DbActiveModal} from "../../../../../modules/modal/modal-ref";

@Component({
    selector: 'db-remove-item-dialog',
    templateUrl: './remove-item-dialog.component.html',
    styleUrls: ['./remove-item-dialog.component.scss'],
    standalone: false
})
export class RemoveItemDialogComponent {
  @Input() alternativePopup = null;

  constructor(
    public activeModal: DbActiveModal,
  ) {
  }

  ngOnInit() {
  }

  removeItem() {
    this.activeModal.close(true);
  }

}
